import React from "react";
import { Button, Flex, Space, Typography } from "antd";
import styles from "./radioButtonGroup.module.css";

export interface RadioOption {
  label: string;
  value: string | number | boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
}

interface RadioButtonGroupProps {
  options: RadioOption[];
  value?: string | number | boolean;
  onChange?: (value: any) => void;
  disabled?: boolean;
  size?: "small" | "middle" | "large";
  title?: React.ReactNode;
  className?: string;
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options,
  value,
  onChange,
  disabled = false,
  size = "small",
  title,
  className,
}) => {
  const handleClick = (optionValue: any) => {
    if (!disabled) {
      onChange?.(optionValue);
    }
  };

  return (
    <Flex vertical>
      {title && (
        <Typography.Text strong className="whitebox-title margin-bottom-xs">
          {title}
        </Typography.Text>
      )}
      <div className={className}>
        <Space size="small">
          {options.map((option) => (
            <Button
              key={String(option.value)}
              type={value === option.value ? "default" : "text"}
              disabled={option.disabled || disabled}
              size={size}
              className={styles.radioButton}
              icon={option.icon}
              onClick={() => handleClick(option.value)}
            >
              {option.label}
            </Button>
          ))}
        </Space>
      </div>
    </Flex>
  );
};
